export default __webpack_public_path__ + "static/media/card5.0764fb34.svg";